import React, {useState} from 'react';
import useUser from '../../../../utility/hooks/useUser';
import {ROLES} from '../../../../constants/roles';
import EmployeeForms from '../../StaffProfile/EmployeeForms';
import RequestAndResponses from './RequestAndResponses';
import AdmicityTabs from '../../../../shared-components/AdmicityTabs';

const STAFF_ROLES = [ROLES.SCHOOL_ADMIN, ROLES.SENIOR_MEMBER_OF_STAFF, ROLES.MEMBER_OF_STAFF, ROLES.EMPLOYEE];

// Maria, 27 October 2026: the staff profile and the parent profile are separate. Every member of staff has the Forms
// tab of their staff profile in My Forms. A member of staff who is also a parent has two tabs: Staff, and Parent with
// the forms and communications they receive as a parent. Parents and students keep the My Forms page they have today.
const MyFormsHome = () => {
    const {user} = useUser();
    const [tabIndex, setTabIndex] = useState(0);
    const isStaff = user.hasRoles(STAFF_ROLES);
    const isParent = user.hasRole(ROLES.PARENT);

    if (isStaff && isParent) {
        return (
            <AdmicityTabs
                tabs={[
                    {label: 'Staff', component: <EmployeeForms self/>},
                    {label: 'Parent', component: <RequestAndResponses asParent/>}
                ]}
                tabIndex={tabIndex}
                onChange={setTabIndex}
                displayDivider
            />
        );
    }

    return isStaff ? <EmployeeForms self/> : <RequestAndResponses/>;
};

export default MyFormsHome;
